import { OrganisationService } from 'src/app/services/organisation.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { fromEvent } from 'rxjs';
import { first } from 'rxjs/operators';
import * as jquery from 'jquery';
import {Summary} from "../../../../models";

@Component({
  selector: 'organisation-listing',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.scss']
})

export class OrganisationListingComponent implements OnInit, AfterViewInit {

  p: any;

  name: string;
  sort_by = '';
  loading = false;
  domainError = '';
  freeTrialError = '';
  nameError = '';
  updateOrgId = 0;
  search_name = '';
  submitted = false;
  organisations = [];
  error = false;
  errorMsg: string;
  processingSearch = 0;
  addOrgForm: FormGroup;
  updateOrgForm: FormGroup;
  successOrgCreate = false;
  successOrgUpdate = false;
  totalRecords = 0;

  currentPage: number;
  lastPage: number;
  pageLinks: number[] = [];
  searchValue = '';
  modalText = 'Loading...';
  loadingData = true;
  typeValue = 'all';

  enterpriseName: string;
  enterpriseType: string;
  enterpriseTotalUsers: number = 0;
  domainRows: any[] = [];
  freeTrialRows: any[] = [];
  newDomain: any;
  newFreeTrial: any;

  nameAlreadyUsed = false;
  domainReqErr = false;
  freeTrialFormatErr = false;
  enterpriseTypeErr = false;
  enterpriseNameReqErr = false;
  enterpriseTotalUsersReqErr = false;

  constructor(
    private route: ActivatedRoute,
    private pageTitleService: Title,
    private organisationService: OrganisationService,
    private formBuilder: FormBuilder
  ) { }

  // Convenience getter for easy access to form fields
  get f() { return this.addOrgForm.controls; }
  get uf() { return this.updateOrgForm.controls; }

  ngOnInit(): void {
    this.setPageTitle();
    this.setFormControls();
    this.showProgressModal();
    this.loadOrganisations();
  }

  ngAfterViewInit(): void {
    this.search();
  }

  setFormControls() {
    this.addOrgForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      type: new FormControl('company', [
        Validators.required
      ]),
      domain: ['', [Validators.required]],
      freeTrial: ['', [Validators.email]]
    });

    this.updateOrgForm = new FormGroup({
      name: new FormControl('', [
        Validators.required
      ]),
      domain: new FormControl('', [
        Validators.required
      ]),
      status: new FormControl('', [
        Validators.required
      ])
    });

  }

  setPageTitle() {
    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Organisations');
  }

  filterByType(type: string) {
    this.typeValue = type;
    this.loadOrganisations(1, this.searchValue, this.typeValue);
  }

  loadOrganisations(pageNumber: number = 1, searchValue: string = '', type = 'all') {
    this.organisations = [];
    this.processingSearch = 1;

    // Show progress modal
    this.showProgressModal();

    this.organisationService.list(pageNumber, searchValue, type)
      .subscribe(
        data => {
          this.organisations = data.data.organisation;
          this.totalRecords = data.data.pagination?.total_records;
          this.lastPage = data.data.pagination?.last_page;
          this.pageLinks = [];
          if (this.totalRecords > 0) {
            this.currentPage = data.data.pagination?.current_page;
            for (let index = 1; index <= this.lastPage; index++) {
              this.pageLinks.push(index);
            }

          }
          // hide progress modal
          this.hideProgressModal();
          this.processingSearch = 0;
          this.loadingData = false;
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  search() {
    const searchBox = document.getElementById('searchOrgInput');
    const keyup$ = fromEvent(searchBox, 'keyup');
    keyup$
      .pipe(
        map((event: any) => {
          this.searchValue = event.target.value;
          return event.target.value;
        }),
        debounceTime(1000),
        distinctUntilChanged()
      )
      .subscribe((text: string) => {
        this.modalText = (text !== '') ? 'Searching...' : 'Loading...';
        this.loadOrganisations(1, this.searchValue, this.typeValue);
      });
  }

  paginate(pageNumber: number) {
    if (pageNumber > 0) {
      this.loadOrganisations(pageNumber, this.searchValue, this.typeValue);
    }
  }

  onKeyUpName() {
    this.nameAlreadyUsed = false;
    this.enterpriseNameReqErr = false;
  }

  onKeyUpTotalUsers() {
    this.enterpriseTotalUsersReqErr = false;
  }

  onKeyUpDomain(i) {
    this.domainReqErr = false;
    jquery('#domainInput_'+i+'').removeClass('error');
    jquery('#domainError_'+i+'').addClass('d-none');
    jquery('#domainError_'+i+'').text('');
  }

  onKeyUpFreeTrial(i) {
    this.freeTrialFormatErr = false;
    jquery('#freeTrialInput_'+i+'').removeClass('error');
    jquery('#freeTrialError_'+i+'').addClass('d-none');
    jquery('#freeTrialError_'+i+'').text('');
  }

  onChangeType() {
    this.enterpriseTypeErr = false;
  }

  resetForm() {
    this.submitted = false;
    this.domainReqErr = false;
    this.freeTrialFormatErr = false;
    this.enterpriseTypeErr = false;
    this.enterpriseNameReqErr = false;
    this.enterpriseTotalUsersReqErr = false;
    this.enterpriseName = '';
    this.enterpriseType = '';
    this.domainRows = [];
    this.freeTrialRows = [];
    this.enterpriseTotalUsers = 0;
    this.addDomainRow();
    this.addFreeTrialRow();
  }

  createOrg() {
    this.submitted = true;
    this.domainReqErr = false;
    this.freeTrialFormatErr = false;
    this.nameAlreadyUsed = false;
    this.enterpriseTypeErr = false;
    this.enterpriseNameReqErr = false;
    let enterpriseName = this.enterpriseName;
    let enterpriseType = this.enterpriseType;
    let enterpriseTotalUsers = this.enterpriseTotalUsers;
    let newDomainString = "";
    let newDomain = [];
    let newFreeTrialString = "";
    let newFreeTrial = [];

    if (enterpriseName == '') {
      this.enterpriseNameReqErr = true;
    }

    if (enterpriseType == '') {
      this.enterpriseTypeErr = true;
    }

    this.domainRows.forEach((domain, dIndex) => {
      if (domain.text == '') {
        if (dIndex == 0) {
          this.domainReqErr = true;
        }
      } else {
        newDomain.push(domain.text);
      }
    });

    if (!enterpriseTotalUsers || enterpriseTotalUsers < 1) {
      this.enterpriseTotalUsersReqErr = true;
    }

    this.freeTrialRows.forEach((freeTrial, dIndex) => {
      if (freeTrial.text != '') {
        if (!this.validateEmail(freeTrial.text)) {
          this.freeTrialFormatErr = true;
          jquery('#freeTrialInput_'+dIndex+'').addClass('error');
          jquery('#freeTrialError_'+dIndex+'').removeClass('d-none');
          jquery('#freeTrialError_'+dIndex+'').text("Invalid email format");
        } else {
          newFreeTrial.push(freeTrial.text);
        }
      }
    });

    // Save data if no errors
    if ( !this.enterpriseNameReqErr && !this.enterpriseTypeErr && !this.domainReqErr && !this.freeTrialFormatErr && !this.enterpriseTotalUsersReqErr) {
      newDomainString = newDomain.join();
      newFreeTrialString = newFreeTrial.join();
      this.loading = true;

      this.organisationService.create(enterpriseName, enterpriseType, newDomainString, newFreeTrialString, enterpriseTotalUsers)
        .pipe(first())
        .subscribe(
          data => {
            this.loading = false;
            if (data.success) {
              jquery('.close').click();
              this.successOrgCreate = true;
              setTimeout(() => {
                this.successOrgCreate = false;
              }, 4000);
              this.loadOrganisations();
            } else {
              if (data.data.domain) {
                for (var key in data.data.domain.error[0]) {
                  jquery('#domainInput_'+key+'').addClass('error');
                  jquery('#domainError_'+key+'').removeClass('d-none');
                  jquery('#domainError_'+key+'').text(data.data.domain.msg[0]);
                }
              }
              if (data.data.free_trial) {
                for (var key in data.data.free_trial.error[0]) {
                  jquery('#freeTrialInput_'+key+'').addClass('error');
                  jquery('#freeTrialError_'+key+'').removeClass('d-none');
                  jquery('#freeTrialError_'+key+'').text(data.data.free_trial.msg[0]);
                }
              }
            }
          },
          error => {
            this.loading = false;
            this.error = true;
            this.submitted = true;
            if (error.error.data.name) {
              this.enterpriseNameReqErr = true;
              this.nameAlreadyUsed = true;
            }
          });
    }

  }

  updateOrg() {
    this.submitted = true;
    // Stop here if there's form errors
    if (this.updateOrgForm.invalid) {
      return;
    }
    this.loading = true;
    this.organisationService.update(this.updateOrgId, this.uf.name.value, this.uf.domain.value, this.uf.status.value)
      .pipe(first())
      .subscribe(
        data => {
          this.loading = false;
          jquery('.close').click();
          if (data.success) {
            this.successOrgUpdate = true;
            setTimeout(() => {
              this.successOrgUpdate = false;
            }, 4000);
          }
          this.loadOrganisations();
        },
        error => {
          this.loading = false;
        });
  }

  getOrgDetails(organisation_id: number) {
    this.updateOrgId = organisation_id;
    this.uf.name.setValue('');
    this.uf.domain.setValue('');
    this.uf.status.setValue('');
    this.organisationService.details(organisation_id)
      .pipe(first())
      .subscribe(data => {
        this.uf.name.setValue(data.data.organisation.name);
        this.uf.domain.setValue(data.data.organisation.domain);
        this.uf.status.setValue(data.data.organisation.status);
      });
  }

  addDomainRow() {
    this.domainRows.push({
      id: 0,
      sequence: this.domainRows.length + 1,
      text: ''
    });
  }

  addFreeTrialRow() {
    this.freeTrialRows.push({
      id: 0,
      sequence: this.freeTrialRows.length + 1,
      text: ''
    });
  }


  deleteDomainRow(index) {
    this.domainRows.splice(index, 1);
  }

  deleteFreeTrialRow(index) {
    this.freeTrialRows.splice(index, 1);
  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }

  private validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

}
